import {ParamSettings, MercantileType} from "../models/ParamSettings";

export const paramSettingsMockValue: ParamSettings[] = [
    {
        id: '1',
        mercantile: MercantileType.Wheat,
        moisture: 14,
        moistureMax: 18,
        moistureMin: 0,
        impurity: 2.5,
        impurityMax: 8,
        impurityMin: 0,
        breakage: undefined,
        breakageMax: undefined,
        breakageMin: undefined,
        defect: undefined,
        defectMax: undefined,
        defectMin: undefined,
        hectoliter: 74,
        hectoliterMax: 80,
        hectoliterMin: 68,
    },
    {
        id: '2',
        mercantile: MercantileType.Barley,
        moisture: 13,
        moistureMax: 18,
        moistureMin: 0,
        impurity: 2,
        impurityMax: 8,
        impurityMin: 0,
        breakage: undefined,
        breakageMax: undefined,
        breakageMin: undefined,
        defect: undefined,
        defectMax: undefined,
        defectMin: undefined,
        hectoliter: undefined,
        hectoliterMax: undefined,
        hectoliterMin: undefined,
    },
    {
        id: '3',
        mercantile: MercantileType.OiledBeet,
        moisture: 9,
        moistureMax: 16,
        moistureMin: 7,
        impurity: 2,
        impurityMax: 6,
        impurityMin: 0,
        breakage: undefined,
        breakageMax: undefined,
        breakageMin: undefined,
        defect: undefined,
        defectMax: undefined,
        defectMin: undefined,
        hectoliter: undefined,
        hectoliterMax: undefined,
        hectoliterMin: undefined,
    },
    {
        id: '4',
        mercantile: MercantileType.Sunflower,
        moisture: 9,
        moistureMax: 16,
        moistureMin: 7,
        impurity: 2,
        impurityMax: 10,
        impurityMin: 1,
        breakage: undefined,
        breakageMax: undefined,
        breakageMin: undefined,
        defect: undefined,
        defectMax: undefined,
        defectMin: undefined,
        hectoliter: undefined,
        hectoliterMax: undefined,
        hectoliterMin: undefined,
    },
    {
        id: '5',
        mercantile: MercantileType.Soya,
        moisture: 13,
        moistureMax: 16,
        moistureMin: 11,
        impurity: 2,
        impurityMax: 10,
        impurityMin: 1,
        breakage: undefined,
        breakageMax: undefined,
        breakageMin: undefined,
        defect: undefined,
        defectMax: undefined,
        defectMin: undefined,
        hectoliter: undefined,
        hectoliterMax: undefined,
        hectoliterMin: undefined,
    },
    {
        id: '6',
        mercantile: MercantileType.Corn,
        moisture: 14,
        moistureMax: 30,
        moistureMin: 15.01,
        impurity: 1,
        impurityMax: 5,
        impurityMin: 0,
        breakage: 4,
        breakageMax: 8,
        breakageMin: 0,
        defect: 2,
        defectMax: 4,
        defectMin: 0,
        hectoliter: undefined,
        hectoliterMax: undefined,
        hectoliterMin: undefined,
    },
];

export const wheatParams = [{
    range1: 4.31,
    range2: 4.84,
    range3: 6.22,
    range4: 6.63,
    range5: 7.12,
    range6: 7.52,
    range7: 7.96,
    range8: 8.41,
    range9: 8.83,
    range10: 9.3,
    range11: 9.99,
    range12: 10.67,
}];

export const cornParams = [{
    range0: 0,//1.16,
    range1: 1.74,
    range2: 2.33,
    range3: 2.91,
    range4: 3.49,
    range5: 4.07,
    range6: 4.65,
    range7: 5.23,
    range8: 5.81,
    range9: 6.40,
    range10: 6.98,
    range11: 7.56,
    range12: 8.14,
    range13: 8.72,
    range14: 9.30,
    range15: 9.88,
    range16: 10.47,
    range17: 11.05,
    range18: 11.63
}];

export const cornParams2 = [{
    range0: 0,//3.00,
    range1: 4.10,
    range2: 5.00,
    range3: 5.90,
    range4: 7.00,
    range5: 8.00,
    range6: 9.00,
    range7: 9.80,
    range8: 10.70,
    range9: 11.50,
    range10: 12.20,
    range11: 14.00,
    range12: 15.00,
    range13: 16.30,
    range14: 17.40,
    range15: 18.30,
    range16: 19.50,
    range17: 20.70,
    range18: 22.00
}];